export const COMM_SERVICE_YEAR = "2027";
